import { useMemo } from 'react';
import usePenetrationReportV2Store from '../../stores/penetrationReportV2Store';
import { filterMarketRecords } from '../../services/penetrationReportV2/penetrationReportV2Service';
import { MarketRecord } from '../../services/penetrationReportV2/types';

/**
 * Single source of truth for "which market records are currently in view":
 * applies the top brand/channel/solution filters plus the selected signal
 * tile (if any). Both the breakdown table and the footprint map derive from
 * this same hook so their filtering logic never drifts apart.
 */
export function useFilteredMarketRecords(allRecords: MarketRecord[]): MarketRecord[] {
  const filters = usePenetrationReportV2Store((s) => s.filters);
  const selectedSignalTile = usePenetrationReportV2Store((s) => s.selectedSignalTile);

  return useMemo(
    () => filterMarketRecords(allRecords, filters, selectedSignalTile),
    [allRecords, filters, selectedSignalTile],
  );
}
